export const GET = {
  REQUEST: 'Transportation/Get/Request',
  SUCCESS: 'Transportation/Get/Success',
  FAILURE: 'Transportation/Get/Failure'
};

export const FOR_SUBMIT = {
  REQUEST: 'Transportation/ForSubmit/Request',
  SUCCESS: 'Transportation/ForSubmit/Success',
  FAILURE: 'Transportation/ForSubmit/Failure'
};

export const UPDATE = {
  REQUEST: 'Transportation/Update/Request',
  SUCCESS: 'Transportation/Update/Success',
  FAILURE: 'Transportation/Update/Failure'
};

export const RESET = {
  SUCCESS: 'Transportation/Reset/Success'
};

export const EXPORT_EXCEL = {
  REQUEST: 'Transportation/ExportExcel/Request',
  SUCCESS: 'Transportation/ExportExcel/Success',
  FAILURE: 'Transportation/ExportExcel/Failure'
};
